import { Outlet } from "react-router-dom";
import BreadcrumbButton from "../../component/backbutton/BackButton";
import { useContext } from "react";
import { LayoutContext } from "../../context/LayoutContext";
import { classNames } from "primereact/utils";

const ContentLayout = ({ }) => {


  const { sidebarCollapsed, isMobile, showBackButton, backButtonLabel, showPageTitle, pageTitle, backButtonNavigateTo, actionButtons, backButtonHandleOnClick } = useContext(LayoutContext);

  return (
    <div className='content-layout'>
      <div className="breadcrumb">
        {showBackButton &&
          <BreadcrumbButton
            showLeftIcon={true}
            styleVariant="text"
            text={backButtonLabel}
            navigateTo={backButtonNavigateTo}
            actionButtons={actionButtons}
            onClick={backButtonHandleOnClick}
          />
        }
      </div>
      {showPageTitle &&
        <div className="title-wrapper">
          <div className="title">{pageTitle}</div>
        </div>
      }
      <div className={classNames('container', { 'menu-collapsed': sidebarCollapsed || isMobile })}>
        <div className={classNames('section', { 'menu-collapsed': sidebarCollapsed || isMobile })}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default ContentLayout;